import { initializeApp } from 'firebase/app';
import { initializeFirestore, persistentLocalCache } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: "AIzaSyAdmkOst3ejtc3zuH0THicv-GtuY4DN3OE",
  authDomain: "fittrack-5889b.firebaseapp.com",
  projectId: "fittrack-5889b",
  storageBucket: "fittrack-5889b.firebasestorage.app",
  messagingSenderId: "789325489890",
  appId: "1:789325489890:web:21946f1fecdcfac3c9e0bb",
  measurementId: "G-NW9F36PQ5T"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize App Check with reCAPTCHA Enterprise safely
let appCheckInstance = null;
if (typeof window !== 'undefined') {
  try {
    if (!window.__appCheckInitialized) {
      // Clean up stale DOM element if restored from bfcache or PWA reload
      const staleDiv = document.getElementById('fire_app_check_[DEFAULT]');
      if (staleDiv && staleDiv.parentNode) {
        staleDiv.parentNode.removeChild(staleDiv);
      }
      appCheckInstance = initializeAppCheck(app, {
        provider: new ReCaptchaEnterpriseProvider('6LdKLW0tAAAAAJDD5Hx6b_8MPthTved0XcCw4-mv'),
        isTokenAutoRefreshEnabled: true
      });
      window.__appCheckInitialized = true;
    }
  } catch (err) {
    console.warn("[AppCheck] App Check initialization skipped or caught:", err);
  }
}
export const appCheck = appCheckInstance;

export const firestoreDb = initializeFirestore(app, {
  localCache: persistentLocalCache()
});
export const storage = getStorage(app);
export const auth = getAuth(app);
auth.languageCode = 'fr';
